import { useMutationApi } from 'utils/api'
import { apiPaths } from 'api/kinerja/kepala-sekolah/config'
import { useKinerjaMutationApi } from 'api/kinerja/utils/api'

import type { UseMutationOptions } from 'react-query'
import type { ResponseKinerjaKs } from 'types/kinerja-ks'

export function useApiPatchPengembanganKompetensi() {
  return useMutationApi<any, any, any>(
    `${apiPaths.kinerja}/update/pengembangan-kompetensi`,
    {
      axiosConfig: {
        method: 'PATCH',
      },
    }
  )
}

export function useApiDeleteSkp(
  npsn: string,
  opts?: UseMutationOptions<ResponseKinerjaKs>
) {
  return useKinerjaMutationApi<any, any, any>(apiPaths.kinerja, {
    axiosConfig: {
      method: 'DELETE',
      params: { npsn },
    },
    mutationConfig: {
      ...opts,
    },
  })
}

export function useApiDeletePelaksanaan(npsn: string) {
  return useKinerjaMutationApi<
    {
      code: number
      message: string
    },
    any,
    any
  >(apiPaths.pelaksanaan, {
    axiosConfig: {
      method: 'DELETE',
      params: { npsn },
    },
  })
}
